import { ProductSpecCode } from '../types/productSchema';

export const TyresShortSpecs = [
  ProductSpecCode.Width,
  ProductSpecCode.Height,
  ProductSpecCode.Diameter,
  ProductSpecCode.Season,
  ProductSpecCode.RunFlat,
];

export const TyresShortSpecsAddSpikes = [
  ProductSpecCode.Width,
  ProductSpecCode.Height,
  ProductSpecCode.Diameter,
  ProductSpecCode.Season,
  ProductSpecCode.Spikes,
  ProductSpecCode.RunFlat,
];

export const TyresShortSpecsAll = [
  ProductSpecCode.ManufacturerCode,
  ProductSpecCode.Size,
  ProductSpecCode.Width,
  ProductSpecCode.Height,
  ProductSpecCode.Diameter,
  ProductSpecCode.Season,
  ProductSpecCode.Spikes,
  ProductSpecCode.LoadIndex,
  ProductSpecCode.SpeedIndex,
  ProductSpecCode.TypeAuto,
  ProductSpecCode.Loads,
  ProductSpecCode.Homologation,
  ProductSpecCode.RunFlat,
  ProductSpecCode.Brand,
  ProductSpecCode.Model,
  ProductSpecCode.Country,
  ProductSpecCode.BrandClass,
  ProductSpecCode.ExtendedWarranty,
  ProductSpecCode.BackProduct,
  ProductSpecCode.SellerCode,
];

export const TruckTyresSpecs = [
  ProductSpecCode.ManufacturerCode,
  ProductSpecCode.Size,
  ProductSpecCode.TruckTyresWidth,
  ProductSpecCode.TruckTyresHeight,
  ProductSpecCode.TruckTyresDiam,
  ProductSpecCode.TruckTyresLoad,
  ProductSpecCode.TruckTyresSpeed,
  ProductSpecCode.TruckTyresType,
  ProductSpecCode.TruckTyresAxle,
  ProductSpecCode.TruckTyresLayer,
  ProductSpecCode.Brand,
  ProductSpecCode.Model,
  ProductSpecCode.BackProduct,
  ProductSpecCode.StandardFactory,
  ProductSpecCode.SellerCode,
];

export const TruckTyresShortSpecs = [
  ProductSpecCode.TruckTyresWidth,
  ProductSpecCode.TruckTyresHeight,
  ProductSpecCode.TruckTyresDiam,
  ProductSpecCode.TruckTyresAxle,
  ProductSpecCode.TruckTyresType,
];

export const DisksShortSpecs = [
  ProductSpecCode.DiskWidth,
  ProductSpecCode.DiskRadius,
  ProductSpecCode.DiskUnitedPcd,
  ProductSpecCode.DiskEt,
  ProductSpecCode.DiskDia,
  ProductSpecCode.DiskProcessWay,
  ProductSpecCode.DiskType,
];

export const DisksSpecsAll = [
  ProductSpecCode.ManufacturerCode,
  ProductSpecCode.Size,
  ProductSpecCode.DiskWidth,
  ProductSpecCode.DiskRadius,
  ProductSpecCode.DiskUnitedPcd,
  ProductSpecCode.DiskEt,
  ProductSpecCode.DiskDia,
  ProductSpecCode.DiskProcessWay,
  ProductSpecCode.DiskColor,
  ProductSpecCode.DiskType,
  ProductSpecCode.Brand,
  ProductSpecCode.Model,
  ProductSpecCode.StandardFactory,
  ProductSpecCode.BackProduct,
  ProductSpecCode.SellerCode,
];

export const AkbSpecs = [
  ProductSpecCode.ManufacturerCode,
  ProductSpecCode.Size,
  ProductSpecCode.AkbWidth,
  ProductSpecCode.AkbHeight,
  ProductSpecCode.AkbLength,
  ProductSpecCode.AkbCapacity,
  ProductSpecCode.AkbPolarity,
  ProductSpecCode.AkbCranking,
  ProductSpecCode.AkbVoltage,
  ProductSpecCode.Brand,
  ProductSpecCode.StandardFactory,
  ProductSpecCode.SellerCode,
];

export const AkbShortSpecs = [
  ProductSpecCode.AkbWidth,
  ProductSpecCode.AkbHeight,
  ProductSpecCode.AkbLength,
  ProductSpecCode.AkbCapacity,
  ProductSpecCode.AkbPolarity,
  ProductSpecCode.AkbVoltage,
];

export const OilsSpecs = [
  ProductSpecCode.ManufacturerCode,
  ProductSpecCode.OilViscosity,
  ProductSpecCode.OilVolume,
  ProductSpecCode.OilApi,
  ProductSpecCode.OilAcea,
  ProductSpecCode.OilType,
  ProductSpecCode.OilLimit,
  ProductSpecCode.Brand,
  ProductSpecCode.SellerCode,
];
